// AIDEV-NOTE: Singleton do Supabase client para uso no browser (Realtime, Auth, REST)
// Usa variaveis de ambiente Vite: VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    '[Supabase] VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY nao configurados. ' +
      'Realtime e funcionalidades Supabase estarao indisponiveis.'
  );
}

// AIDEV-NOTE: Mesmo sem credenciais, criamos o client com strings vazias
// para evitar erros de import em modulos que dependem dele.
// O Realtime simplesmente nao conectara.
export const supabase: SupabaseClient = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '', {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});
